import React, { useEffect, useMemo, useState } from "react";
import {
  Layout,
  Card,
  Button,
  Input,
  Radio,
  Popconfirm,
  Form,
  InputNumber,
  message,
  Select,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useSelector } from "react-redux";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";

const GroupConfiguration = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [refetch2, setRefetch2] = useState(false);
  const [refetch3, setRefetch3] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  const showDrawer2 = () => {
    setOpen2(true);
  };

  const onClose2 = () => {
    setOpen2(false);
  };
  const showDrawer3 = () => {
    setOpen3(true);
  };

  const onClose3 = () => {
    setOpen3(false);
  };
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  console.log(color);
  const { isdarkMode } = mode;

  const [externalEnergySources, setExternalEnergySources] = useState([]);
  const [updateExternalEnergySources, setUpdateExternalEnergySources] =
    useState([]);
  const [productionData, setProductionData] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);

  const [newExternalSource, setNewExternalSource] = useState("");
  const [newProductionData, setNewProductionData] = useState("");
  const [newResourceDetail, setNewResourceDetail] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedSubGroupValue, setSelectedSubGroupValue] = useState("");
  const [groupData, setGroupData] = useState([]);
  const [subGroupData, setSubGroupData] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  const [groupname, setGroupname] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [groupID, setGroupId] = useState();
  const [consumptionDetail, setConsumptionDetails] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  useEffect(() => {
    //  Group Name
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}`,
    }).then((res) => {
      // if (res) {
      //   const filteredGroupnames = res.filter(
      //     (group) => group.groupID === 6 || group.groupID === 7
      //   );
      //   setGroupname(filteredGroupnames);
      // }
      if (res) {
        setGroupname(res);
      }
    });

    //  Converter Data
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`,
    }).then((res) => {
      setgetFlowConverterResData(res);
    });

    //  Consumption Details
    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_CONSUMPTION_DETAILS}`,
    }).then((res) => {
      setConsumptionDetails(res);
    });
  }, []);

  // Sub group
  useEffect(() => {
    if (groupID !== undefined) {
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_SUB_GROUPDETAILS}?GroupId=${groupID}`,
      })
        .then((res) => {
          setSubGroup(res);
        })
        .catch((error) => {
          console.error("Error fetching sub groups:", error);
          setSubGroup([]);
        });
    }
  }, [groupID]);
  useEffect(() => {
   form1.setFieldsValue({
  subgroup: undefined,
  convertername: undefined,
  consumption: undefined,
  metertype: undefined,
  meters: undefined,
});

  }, [groupID]);

  // Converter
  useEffect(() => {
    if (converterGroupId) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        setnsGetFlowConverterResData(res);
      });
    }
  }, [converterGroupId]);

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const getGroup = (formValues) => {
    console.log(formValues);
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GROUP_DETAILS}?Module=1`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if (res) {
        setGroupData(res);
      }
    });
  };
  const getSubGroup = () => {
    console.log(selectedValue);
    const url = `${APIConstants.ELECTRICAL_SUB_GROUP_DETAILS}?GroupId=${selectedValue}`;
    // const url = `${APIConstants.DEVICE_DETAILS}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      // body:formValues
    }).then((res) => {
      console.log(res);
      if (res) {
        setSubGroupData(res);
      }
    });
  };
  const getDevices = (values) => {
    console.log("Form values:", values);

    if (values) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELCTRICAL_SUBGROUP_METER_DETAILS}?SubGroupID=${values}`,
      })
        .then((res) => {
          console.log("Meter Details:", res);
          if (res && res.length > 0) {
            //  setShowGrid(true);
            setDeviceData(res);
          }
        })
        .catch((err) => {
          console.error("Error fetching meter details", err);
        });
    } else {
      console.error("Something went wrong");
    }
  };
  useEffect(() => {
    console.log(selectedSubGroupValue);
    getDevices(selectedSubGroupValue);
  }, [selectedSubGroupValue]);

  useEffect(() => {
    getSubGroup();
  }, [selectedValue, refetch3]);
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_EXTERNAL_ENERGY_SOURCE}`,
    }).then((res) => {
      console.log(res);
      function addIsUpdateFlag(sourceArray) {
        return sourceArray.map((item) => ({
          ...item,
          // isUpdate: false,
        }));
      }

      if (res && res.length > 0) {
        const updatedSources = addIsUpdateFlag(res); // originalSources is your input array
        console.log(updatedSources);

        setExternalEnergySources(updatedSources);
        setUpdateExternalEnergySources(updatedSources);
      }
    });
  }, [refetch]);
  useEffect(() => {
    getGroup();
  }, [refetch2]);

  const deviceCols = [
    { headerName: "S.No", field: "autoID", width: 80 },
    { headerName: "Group ID", field: "groupID", flex: 1 },
    { headerName: "SubGroup ID ", field: "metername", flex: 1 },
    { headerName: "Meter ID", field: "meterid", flex: 1 },
    { headerName: "MeterName", field: "metername", flex: 1 },
    { headerName: "Site Name", field: "sitename", flex: 1 },
    { headerName: "Function", field: "groupName", flex: 1 },

    // {
    //   headerName: "Actions",
    //   width: 150,
    //   cellRenderer: (params) => (
    //     <div className="space-x-2">
    //       <Popconfirm
    //         title="Are you sure to delete this Converter"
    //         icon={<QuestionCircleOutlined style={{ color: "red" }} />}
    //         onConfirm={() => deleteExternalEnergy(params.data)}
    //         trigger="click"
    //       >
    //         <Button className="text-red-500">
    //           <DeleteOutlined />
    //         </Button>
    //       </Popconfirm>
    //     </div>
    //   ),
    // },
  ];

  const groupCols = [
    {
      headerName: "",
      field: "select",
      width: 30,
      headerCheckboxSelection: false, // optional
      cellRenderer: (params) => {
        return (
          <input
            type="checkbox" // Change to "checkbox" if you prefer
            name="rowSelect"
            defaultChecked={params.data.groupID === selectedValue}
            onChange={(e) => {
              if (e.target.checked) {
                console.log("Selected Row:", params.data);
                setSelectedValue(params.data.groupID);
              } else {
                console.log("Unchecked Row:", params.data);
              }
            }}
          /> 
        ); 
      },
    },
    { headerName: "Group ID", field: "groupID", width: 100 },
    { headerName: "Department", field: "department",  width: 110 },
    {
      headerName: "Actions",
      width: 80,
      // flex:1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}

            <Popconfirm
              title="Are you sure to delete this Converter"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteGroup(params.data)}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  console.log(selectedSubGroupValue)
  console.log(subGroupData)

  const subGroupCols = [
    {
      headerName: "",
      field: "select",
      width: 30,
      headerCheckboxSelection: false, // optional
      cellRenderer: (params) => {
        return (
          <input
            type="checkbox" // Change to "checkbox" if you prefer
            name="rowSelect"
            defaultChecked={params.data.subGroupID === selectedSubGroupValue}
            onChange={(e) => {
              if (e.target.checked) {
                console.log("Selected Row:", params.data);
                setSelectedSubGroupValue(params.data.subGroupID);
              } else {
                console.log("Unchecked Row:", params.data);
              }
            }}
          />
        );
      },
    },
    { headerName: "Sub Group ID", field: "subGroupID", width: 110 },
    { headerName: "Sub Group", field: "subGroupName", width:110 },
    {
      headerName: "Actions", 
      width: 80,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}

            <Popconfirm
              title="Are you sure to delete this Converter"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteSubGroup(params.data)}
              trigger="click"
            >
              <Button className="text-red-500">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const handleAddExternalEnergy = () => {
    console.log(newExternalSource);
    const newData = {
      sourceID: externalEnergySources.length + 1,
      sourceName: newExternalSource,
    };
    setExternalEnergySources([newData, ...externalEnergySources]);
    setNewExternalSource("");
    onClose();
  };

  const onFinish2 = (values) => {
    //   setFormValues(values);
    form2.resetFields();
    console.log(values); // Log the form values
    //   handleOk();
    insertGroup(values);
  };

  const insertGroup = (formValues) => {
    console.log(formValues);
    const url = `${APIConstants.ELECTRICAL_INSERT_GROUP}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: formValues,
    }).then((res) => {
      setRefetch2(!refetch2);
      onClose2();
      handleNotification(res?.message, "success");
      console.log(res?.message);
    });
  };
  const deleteGroup = (formValues) => {
    console.log(formValues);

    const body = {
      groupID: formValues.groupID,
    };

    const url = `${APIConstants.ELECTRICAL_GROUP_DELETE}`;

    console.log(url);
    console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      console.log(res);
      onClose2();
      setRefetch2(!refetch2);
      handleNotification(res.message, "error");
    });
  };

  const onFinish3 = (values) => {
    // setFormValues(values);
    console.log(values);
    const formData = (values) => {
      return {
        groupID: values.groupID?.key || null,
        subGroupType: "Plus" || null,
        subGroupName: values.subGroupName || null,
      };
    };
    const formValues = formData(values);
    console.log(formValues);
    onClose3();
    insertDevice(formValues);
    form3.resetFields(); // Reset form fields after submission
  };

  const insertDevice = (formValues) => {
    console.log(formValues);
    const url = `${APIConstants.ELECTRICAL_INSERT_SUB_GROUP}`;
    console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: formValues,
    })
      .then((res) => {
        console.log(res);
        // setRefetch3(!refetch3)
     
        handleNotification("Sub Group added successfully!", "success");
      })
      .catch((err) => {
        handleNotification("Something went wrong!", "error");
      });
  };
  const deleteSubGroup = (formValues) => {
    console.log(formValues);
    // setSelectedValue(formValues.groupID)

    const body = {
      subGroupID: formValues.subGroupID,
    };

    const url = `${APIConstants.ELECTRICAL_SUB_GROUP_DELETE}`;

    console.log(url);
    console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      console.log(res);
      //   setRefetch(!refetch);
      handleNotification(res.message, "error");
    });
  };
  const onFinish1 = (values) => {
    const selectedGroup = groupname.find(
      (group) => group.department === values.groupname
    );
    const selectedSubGroup = subGroup.find(
      (subgroup) => subgroup.subGroupName === values.subgroup
    );
    const selectedConverter = getFlowConverterResData.find(
      (converter) => converter.sitE_ID === values.convertername
    );
    const selectedConsumption = consumptionDetail.find(
      (consumption) => consumption.parametername === values.consumption
    );

    const meterIdsAndNames = selectedMeterIds
      .map(({ meterId, meterName }) => `${meterId}$${meterName}`)
      .join(",");
    const meterTypeValue = values.metertype === "type1";

    const transformedData = {
      siteID: selectedConverter.sitE_ID,
      departmentID: selectedGroup.groupID,
      meterIdsandMeterName: meterIdsAndNames,
      department: selectedGroup.department,
      siteName: selectedConverter.sitename,
      meterType: meterTypeValue,
      subGroupID: selectedSubGroup.subGroupID,
      consumption: selectedConsumption.parameterid,
    };

    console.log("Transformed Data to Submit:", transformedData);

    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_INSERT_GROUP_DETAILS}`,
      body: transformedData,
    })
      .then((res) => {
        console.log("API Response:", res);
        console.log("Transformed Data:", transformedData);
        message.success("Group Config saved successfully!");

   onClose();
    form1.resetFields();
        })
      .catch((error) => {
        console.error("Error saving Group Config:", error);
      });
  };

  console.log(externalEnergySources);

  console.log(productionData);
  console.log(resourceDetails);
  const handleMeterChange = (selectedKeys) => {
    const selectedMeters = selectedKeys.map((selectedKey) => {
      const meter = nsGetFlowConverterResData.find((meter) => meter.meterid === selectedKey);
      return meter ? { meterId: meter.meterid, meterName: meter.metername } : null;
    }).filter(Boolean);

    setSelectedMeterIds(selectedMeters);
  };
  useEffect(()=>{
    setDeviceData([]);
    setSelectedSubGroupValue('') 
  },[selectedValue])
  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Groups
        </h2>

        <div className="flex gap-4 h-[90vh]">
          {/* Group */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Group
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer2()}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={groupData}
                columnDefs={groupCols}
                domLayout="normal"
              />
            </div>
          </Card>

          {/* Sub Group */}
          {/* {subGroupData.length > 0 && ( */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Sub Group
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer3()}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={subGroupData}
                columnDefs={subGroupCols}
                domLayout="normal"
              />
            </div>
          </Card>
          {/* )} */}
          {/* External Energy Sources */}
          {/* {deviceData.length > 0 && ( */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Grouping Devices
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer()}>
                Add +
              </Button>
            }
            className={`w-2/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={deviceData}
                columnDefs={deviceCols}
                domLayout="normal"
                rowHeight={50}
              />
            </div>
          </Card>
          {/* )} */}
        </div>
      </div>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form1}
            name="add-Group-Config"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
            }}
            labelAlign="left"
            onFinish={onFinish1}
            className="p-3"
          >
            {/* Group Name */}
            <Form.Item
              label="Group Name"
              name="groupname"
              rules={[{ required: true, message: "Please select Group Name!" }]}
            >
              <Select
                placeholder="Select Group Name"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
                onChange={(value) => {
                  const selectedGroup = groupname.find(
                    (group) => group.department === value
                  );
                  if (selectedGroup) {
                    setGroupId(selectedGroup.groupID);
                  }
                }}
              >
                {groupname.map((group) => (
                  <Select.Option key={group.groupID} value={group.department}>
                    {group.department}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* Sub Group */}
            <Form.Item
              label="Sub Group"
              name="subgroup"
              rules={[{ required: true, message: "Please select Sub Group!" }]}
            >
              <Select
                placeholder="Select Sub Group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {subGroup &&
                  subGroup.map((group) => (
                    <Select.Option
                      key={group.subGroupID}
                      value={group.subGroupName}
                    >
                      {group.subGroupName}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {/* Converter */}
            <Form.Item
              label="Converter Name"
              name="convertername"
              rules={[
                { required: true, message: "Please select Converter Name!" },
              ]}
            >
              <Select
                placeholder="Select Converter Name"
                onChange={(value) => setConverterGroupId(value)}
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {getFlowConverterResData &&
                  getFlowConverterResData.map((val) => (
                    <Select.Option key={val.sitE_ID} value={val.sitE_ID}>
                      {val.sitename}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {/* Consumption */}
            <Form.Item
              label="Consumption"
              name="consumption"
              rules={[
                { required: true, message: "Please select Consumption!" },
              ]}
            >
              <Select
                placeholder="Select Consumption"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {consumptionDetail &&
                  consumptionDetail.map((param) => (
                    <Select.Option
                      key={param.parameterid}
                      value={param.parametername}
                    >
                      {param.parametername}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            {/* Meter Type */}
            <Form.Item
              label="Device Type"
              name="metertype"
              rules={[
                { required: true, message: "Please select Device Type!" },
              ]}
            >
              <Select
                placeholder="Select Device Type"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                <Select.Option value="type1">Plus</Select.Option>
                <Select.Option value="type2">Minus</Select.Option>
              </Select>
            </Form.Item>

            {/* TreeSelect for Meters */}
            <Form.Item
              label="Device"
              name="meters"
              rules={[{ required: true, message: "Please select Meters!" }]}
            >
              <Select
                mode="multiple"
                placeholder="Select Device"
                value={selectedMeterIds}
                onChange={handleMeterChange}
                optionLabelProp="label"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {nsGetFlowConverterResData.map((meter) => (
                  <Select.Option
                    key={meter.meterid}
                    value={meter.meterid}
                    label={meter.metername}
                  >
                    {meter.metername}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            {/* Footer Buttons */}
            {/* <Form.Item
                   wrapperCol={{
                     offset: 16,
                     span: 16,
                   }}
                 >
                   <Button key="back" className="mr-3" onClick={handleCancel}>
                     Cancel
                   </Button>
         
                   <Button htmlType="submit" type="primary" loading={loading}>
                     Save
                   </Button>
                 </Form.Item> */}
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={() => form1.submit()}
            >
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer2}
        open={open2}
        onClose={onClose2}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form2}
            name="Group-add-form"
            className="font-bold"
            layout="horizontal"
            style={{ maxWidth: 600 }}
            labelCol={{ span: 8, offset: 0 }}
            labelAlign="left"
            onFinish={onFinish2}
          >
            <Form.Item
              label="Group"
              name="department"
              rules={[{ required: true, message: "Please input department!" }]}
            >
              <Input className="ml-0" />
            </Form.Item>

            <Form.Item
              label="Group ID"
              name="groupID"
              rules={[{ required: true, message: "Please input Group ID!" }]}
            >
              <InputNumber style={{ width: "100%" }} />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button
              // htmlType="submit"
              type="primary"
              //   disabled={!newProductionData.trim()}
              onClick={() => form2.submit()}
            >
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer3}
        open={open3}
        onClose={onClose3}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form3}
            name="Group-add-form"
            className="font-bold"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
              offset: 0,
            }}
            labelAlign="left"
            onFinish={onFinish3}
          >
            <Form.Item
              label="Group Name"
              name="groupID"
              rules={[
                {
                  required: true,
                  message: "Please select a group!",
                },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {groupData.map((i) => (
                  <Option key={i.groupID} value={i.department}>
                    {i.department}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Sub-Group Name"
              name="subGroupName"
              rules={[
                {
                  required: true,
                  message: "Please input Group ID!",
                },
              ]}
            >
              <Input
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form3.submit()}>
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default GroupConfiguration;
